import { connect } from 'react-redux'
import {
  setPaymentProfileForm,
  setPaymentMethod
} from 'actions/account/checkout'

const mapStateToProps = ({ checkout: { paymentProfileForm } }) => ({
  paymentProfileForm
})

const actions = {
  setPaymentProfileForm,
  setPaymentMethod
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux
